<template>
  <div>
    <ul class="circle-ul">
      <li v-for="(item,index) of imageList" :key="item.id" class="circle-li">
        <div @click="changeList(index)" class="imagContainer">
          <img :src="item" :class="SelectClass(index)" alt />
        </div>
      </li>
    </ul>
  </div>
</template>


<script>
export default {
  data() {
    return {
      selecttor: "",
      imageList: [
        this.$conf.MessageAPI + "/images/group_img_1.svg",
        this.$conf.MessageAPI + "/images/group_img_2.svg",
        this.$conf.MessageAPI + "/images/group_img_3.svg",
        this.$conf.MessageAPI + "/images/group_img_4.svg",
        this.$conf.MessageAPI + "/images/group_img_5.svg",
        this.$conf.MessageAPI + "/images/group_img_6.svg",
        this.$conf.MessageAPI + "/images/group_img_7.svg",
        this.$conf.MessageAPI + "/images/group_img_8.svg",
        this.$conf.MessageAPI + "/images/group_img_9.svg",
        this.$conf.MessageAPI + "/images/group_img_10.svg"
      ]
    };
  },
  methods: {
    SelectClass(index) {
      if (
        this.pickImageFileName(this.imageList[index]) ==
        this.pickImageFileName(this.selecttor)
      ) {        
        return "";
      } else {        
        return "gray";
      }
    },

    changeList(index) {
      this.selecttor = this.imageList[index];
    },

    //用/分割後取最後一part
    pickImageFileName(imgURL) {
      var ary = imgURL.split("/");
      return ary[ary.length - 1];
    }
  }
};
</script>

<style>
.circle-ul {
  margin: 0 0 0 50px;
  width: 90%;
  height: 50px;
}
.circle-li {
  margin-right: 15px;
  width: 40px;
  float: left;
}

.imagContainer {
  width: 40px;
  height: 40px;
}

.gray {
-webkit-filter: grayscale(100%);
-ms-filter: grayscale(100%);
filter: grayscale(100%);
filter: gray;
filter: alpha(opacity = 30);
opacity: 0.3;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/FriendGroup_ChoisePhoto.vue